var _polygon, _polygon2, _path, _path2, _path3, _path4, _polygon3, _path5, _path6, _path7, _polygon4, _polygon5, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilesImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.22,260.26c-89.62-51.75-234.46-51.75-323.5,0s-88.57,135.64,1,187.39,234.47,51.74,323.51,0S500.85,312,411.22,260.26Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105,315.68c29.62-17.1,77.49-17.1,106.91,0,26,15.11,28.89,38.51,8.79,55.55,16.22-1,33,2.09,45.42,9.29,21.75,12.64,21.63,33.13-.25,45.76s-57.26,12.64-79,0c-17.3-10-20.75-25.07-10.42-37.16-24.93,3.61-52.37-.23-71.79-11.51C75.19,360.51,75.34,332.79,105,315.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.05,359.18l-122.88-71.5a2.29,2.29,0,0,1,0-4l45.68-26.55a2.3,2.3,0,0,1,2.3,0l124,72.17a2.29,2.29,0,0,1,0,4l-44.53,25.88A4.58,4.58,0,0,1,396.05,359.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,387.38c-7.29-4.2-19.06-4.2-26.3,0s-7.2,11,.09,15.23,19.06,4.21,26.29,0S427.29,391.59,420,387.38Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "118.05 97.43 83.68 117.28 83.75 143.55 118.13 123.7 118.05 97.43",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.05 97.43 118.13 123.7 121.31 125.55 121.23 95.6 118.05 97.43",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.75 143.55 83.77 147.23 121.31 125.55 118.13 123.7 83.75 143.55",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.06,89,79.82,115.08l.11,38.79,45.24-26.12ZM83.77,147.23l0-3.68-.07-26.27,34.37-19.85,3.18-1.83.08,30Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.06 88.96 121.88 87.11 76.64 113.23 79.82 115.08 125.06 88.96",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.64 113.23 76.75 152.02 79.93 153.87 79.82 115.08 76.64 113.23",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.03 156.39 83.66 176.24 83.73 202.51 118.11 182.66 118.03 156.39",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.03 156.39 118.11 182.66 121.29 184.51 121.2 154.56 118.03 156.39",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.73 202.51 83.74 206.19 121.29 184.51 118.11 182.66 83.73 202.51",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,147.92,79.8,174l.11,38.79,45.24-26.12Zm-41.3,58.27v-3.68l-.07-26.28L118,156.39l3.17-1.83.09,29.95Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.04 147.92 121.86 146.07 76.61 172.19 79.8 174.04 125.04 147.92",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.61 172.19 76.72 210.98 79.91 212.83 79.8 174.04 76.61 172.19",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.16,113.63h0c.41-.19.82-.4,1.23-.6h0C172,113.24,171.57,113.44,171.16,113.63Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.72,113.85h0l.46-.22h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.19 62.44 175.79 67.87 166.23 73.39 175.79 67.87 185.19 62.44",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.27 93.43 185.25 84.71 185.23 76.74 185.25 84.71 185.27 93.43",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.4,113l.26-.13-.26.13Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.38 131.66 185.36 124.37 185.34 117.99 185.36 124.37 185.38 131.66",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.07,115.35c1.2-.43,2.42-.94,3.64-1.5h0C169.49,114.41,168.27,114.92,167.07,115.35Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.27 89.36 157.35 117.37 157.4 133.6 157.35 117.37 157.27 89.36",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.36,124.37l0-6.38-.29.16-.53.32c-4.71,2.84-9.44,7.32-13.85,12.15-.73.8-1.45,1.61-2.16,2.42-3.71,4.26-7.34,8.76-11.08,13l0,10.31,4.5-2.59A98.94,98.94,0,0,1,185.36,124.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.41,140.19l0-8.53a53.79,53.79,0,0,0-9.56,14.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.82,145.72a53.79,53.79,0,0,1,9.56-14.06l0-7.29A98.94,98.94,0,0,0,162,153.73l13.86-8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.72,113.85h0",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.16,113.63h0",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.42,115.58l.65-.23c1.2-.43,2.42-.94,3.65-1.5l.44-.22c.41-.19.83-.39,1.24-.6.71-.37,1.42-.74,2.14-1.15-.72.41-1.43.78-2.14,1.15l.26-.13c.62-.32,1.25-.66,1.88-1l.4-.23.33-.19a68.65,68.65,0,0,0,9.62-6.89l.42-.36,0-10.78c-6.84,3.5-13.57,4.59-19,2.9a16.7,16.7,0,0,1-9-7l.08,28A33.33,33.33,0,0,0,166.42,115.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.67,130.62c4.41-4.83,9.14-9.31,13.85-12.15l.53-.32.29-.16v-6.18A133.92,133.92,0,0,0,160.13,131c-.91.87-1.82,1.76-2.73,2.61l0,12.41c3.74-4.21,7.37-8.71,11.08-13C169.22,132.23,169.94,131.42,170.67,130.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.33,111.81l0-7.6-.42.36a68.65,68.65,0,0,1-9.62,6.89l-.33.19-.4.23c-.63.36-1.26.7-1.88,1l-.26.13a1.4,1.4,0,0,0-.17.09h0a1.4,1.4,0,0,1,.17-.09c-.41.2-.82.41-1.23.6l-.46.22c-1.22.56-2.44,1.07-3.64,1.5l.68-.25-.68.25-.65.23a33.33,33.33,0,0,1-9.07,1.79l.05,16.23c.91-.85,1.82-1.74,2.73-2.61A133.92,133.92,0,0,1,185.33,111.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.25,84.71l0-8c-4.32-1-7.68-4.16-9.44-8.87l-9.56,5.52A19.74,19.74,0,0,0,185.25,84.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.27,96.33c5.43,1.69,12.16.6,19-2.9l0-8.72a19.74,19.74,0,0,1-19-11.32l-9,5.19,0,10.77A16.7,16.7,0,0,0,166.27,96.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.76,59.73l-31.1,18,.23,81.35,31.1-18Zm-29.3,96.59,0-10.31,0-12.41-.05-16.23-.08-28,0-10.77,9-5.19,9.56-5.52,9.4-5.43,0,14.3,0,8,0,8.72,0,10.78,0,7.6V118l0,6.38,0,7.29,0,8.53-9.59,5.53h0l-13.86,8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.21,113.13h0",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.23,113.12a1.4,1.4,0,0,1,.17-.09",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.54,111.88c-.72.41-1.43.78-2.14,1.15",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.4,
    y1: 113.03,
    x2: 172.4,
    y2: 113.03,
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.07,115.35l.68-.25",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.23,76.74l0-14.3-9.4,5.43C177.55,72.58,180.91,75.73,185.23,76.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.99 141.08 155.89 159.04 155.89 161.2 188.85 142.17 186.99 141.08",
    style: {
      fill: "#cacaca"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.75 59.73 186.99 141.08 188.85 142.17 188.62 58.66 186.75 59.73",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.62,50l-43,24.82.27,95,43-24.82ZM155.89,161.2V159l-.23-81.35,31.1-18,1.86-1.07.23,83.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.62 50 190.07 48.09 147.08 72.91 150.62 74.82 193.62 50",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.08 72.91 147.35 167.96 150.89 169.86 150.62 74.82 147.08 72.91",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.13 107.41 116.51 114.78 116.53 122 85.35 140 85.33 132.79 91.27 120.98 96.61 125.13 94.72 130.99 97.46 125.78 107.13 107.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.89,111c1.47-.85,2.66-.17,2.67,1.52a5.86,5.86,0,0,1-2.65,4.59c-1.47.84-2.66.16-2.67-1.52A5.85,5.85,0,0,1,96.89,111Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.11 166.36 116.48 173.75 116.5 180.96 85.33 198.96 85.31 191.75 91.25 179.94 96.58 184.09 94.7 189.95 97.43 184.74 107.11 166.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.87,170c1.47-.85,2.66-.17,2.66,1.52a5.85,5.85,0,0,1-2.64,4.59c-1.47.84-2.67.16-2.67-1.52A5.82,5.82,0,0,1,96.87,170Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Furniture--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "287.13 285.93 282.6 288.57 282.61 283.32 287.13 285.93",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.72 257.95 282.72 257.89 282.72 257.89 282.72 257.89 282.72 257.95",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.99,
    y: 225.97,
    height: 127.6,
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.79 232.44 393.32 296.19 393.32 296.19 282.79 232.44",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.13,285.93l106.09,61.2v5.24l4.72,2.73.17-61.63-120-69.25-.18,61.62,4.73,2.73v-5.25Zm106.14,30.25L282.74,252.42l.05-20,110.53,63.75h0Zm-.08,25.45L282.66,277.88l.06-19.93v-.06h0l110.53,63.76h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.67 277.88 282.72 257.95 282.72 257.89 393.25 321.65 393.25 321.65 393.19 341.63 282.67 277.88",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.74 252.42 282.79 232.44 393.32 296.19 393.32 296.19 393.27 316.18 282.74 252.42",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.1 293.47 444.93 266.26 444.75 327.89 397.93 355.1 398.1 293.47",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.1 293.47 278.05 224.22 324.87 197.01 444.93 266.26 398.1 293.47",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.33,276.14v3.59c0,1.8-1.28,2.53-2.85,1.62l-13.59-7.84a6.23,6.23,0,0,1-2.82-4.9V265Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.33 272.77 345.32 276.14 326.07 265.02 326.08 261.65 345.33 272.77",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "345.33 272.77 345.32 276.14 326.07 265.02 326.08 261.65 345.33 272.77"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M345.33,301.81v3.58c0,1.81-1.28,2.53-2.85,1.63l-13.59-7.84a6.24,6.24,0,0,1-2.82-4.9v-3.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.33 298.44 345.32 301.81 326.07 290.69 326.08 287.32 345.33 298.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "345.33 298.44 345.32 301.81 326.07 290.69 326.08 287.32 345.33 298.44"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.54,363.18l-17.64.52-17.63-.52c-.76,11.91,1.56,24.05,4.77,30h0a8.09,8.09,0,0,0,3.49,3.55c5.21,3,13.62,3,18.79,0a7.87,7.87,0,0,0,3.49-3.64C423,387.11,425.3,375,424.54,363.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.33,356c6.92,4,6.95,10.46.09,14.45s-18,4-24.95,0S387.53,360,394.39,356,412.42,352,419.33,356Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.6,357.55c5.39,3.11,5.42,8.16.07,11.27s-14.07,3.11-19.46,0-5.42-8.16-.07-11.27S411.21,354.43,416.6,357.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.6,357.55c5.39,3.11,5.42,8.16.07,11.27s-14.07,3.11-19.46,0-5.42-8.16-.07-11.27S411.21,354.43,416.6,357.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M435.9,287.92c-39.74,13-40.1,39.61-31.14,58.54,2.26,3.83,9.1,5.89,15.05-17.66l-10.44,1.34L421.53,324l3.16-9.44-10.14.75,12.88-5.41A190.84,190.84,0,0,1,435.9,287.92Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.9,287.92c-39.74,13-40.1,39.61-31.14,58.54,2.26,3.83,9.1,5.89,15.05-17.66l-10.44,1.34L421.53,324l3.16-9.44-10.14.75,12.88-5.41A190.84,190.84,0,0,1,435.9,287.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.9,287.92c-39.74,13-40.1,39.61-31.14,58.54,2.26,3.83,9.1,5.89,15.05-17.66l-10.44,1.34L421.53,324l3.16-9.44-10.14.75,12.88-5.41A190.84,190.84,0,0,1,435.9,287.92Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.66,294.57c-21,15.91-22.85,34.15-16.93,53.19C405.63,331,403.37,314,424.66,294.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.58,314.93c39.18,5.52,43.93,30.22,38.73,49.35-1.46,3.94-7.49,7-16.95-13.95l9.95-.49L388,346.12l-4.51-8.27,9.57-1L380.12,334A180.63,180.63,0,0,0,368.58,314.93Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.58,314.93c39.18,5.52,43.93,30.22,38.73,49.35-1.46,3.94-7.49,7-16.95-13.95l9.95-.49L388,346.12l-4.51-8.27,9.57-1L380.12,334A180.63,180.63,0,0,0,368.58,314.93Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.58,314.93c39.18,5.52,43.93,30.22,38.73,49.35-1.46,3.94-7.49,7-16.95-13.95l9.95-.49L388,346.12l-4.51-8.27,9.57-1L380.12,334A180.63,180.63,0,0,0,368.58,314.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.16,319.26c22.16,11.33,26.95,28,24.6,46.72C403.93,350,403.22,333.85,380.16,319.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.37,324.19c-35.93.59-43,22.32-40.43,40.14.88,3.72,6,7.15,16.84-10.67l-8.91-1.56,11.55-2,5-6.95-8.52-2,11.95-1.17A164.7,164.7,0,0,1,447.37,324.19Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.45,326.79c-21.24,7.74-27.43,22.23-27.4,39.36C411.59,351.85,414,337.37,436.45,326.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.37,324.19c-35.93.59-43,22.32-40.43,40.14.88,3.72,6,7.15,16.84-10.67l-8.91-1.56,11.55-2,5-6.95-8.52-2,11.95-1.17A164.7,164.7,0,0,1,447.37,324.19Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "331.04 40.1 324.7 36.48 324.3 175 324.32 175.01 375.4 204.18 375.42 196.93 375.8 65.66 331.04 40.1",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.66 171.37 331.04 40.1 324.7 36.48 324.3 175 324.32 175.01 330.68 171.38 330.66 171.37",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.42 196.93 330.68 171.38 324.32 175.01 375.4 204.18 375.42 196.93",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.94 80.01 394.6 76.39 394.2 214.91 394.22 214.92 445.3 244.09 445.32 236.84 445.7 105.57 400.94 80.01",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.56 211.28 400.94 80.01 394.6 76.39 394.2 214.91 394.22 214.92 400.58 211.29 400.56 211.28",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.32 236.84 400.58 211.29 394.22 214.92 445.3 244.09 445.32 236.84",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.56,256.76c10.1,7,21.48,11.87,29.92,21.28,15.75,17.56,16.12,45.82,3.75,65.91s-35.39,32.17-58.83,34.93c-24.59,2.9-50.39-3.9-69.68-19.42S71.16,319.7,71.17,294.94,83.86,245.53,104.6,232c18.92-12.34,46.1-15.86,65.08-1.74,9.6,7.14,16,17.67,25.57,24.83C196,255.67,196.78,256.22,197.56,256.76Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.56,256.76c10.1,7,21.48,11.87,29.92,21.28,15.75,17.56,16.12,45.82,3.75,65.91s-35.39,32.17-58.83,34.93c-24.59,2.9-50.39-3.9-69.68-19.42S71.16,319.7,71.17,294.94,83.86,245.53,104.6,232c18.92-12.34,46.1-15.86,65.08-1.74,9.6,7.14,16,17.67,25.57,24.83C196,255.67,196.78,256.22,197.56,256.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.56,256.76c10.1,7,21.48,11.87,29.92,21.28,15.75,17.56,16.12,45.82,3.75,65.91s-35.39,32.17-58.83,34.93c-24.59,2.9-50.39-3.9-69.68-19.42S71.16,319.7,71.17,294.94,83.86,245.53,104.6,232c18.92-12.34,46.1-15.86,65.08-1.74,9.6,7.14,16,17.67,25.57,24.83C196,255.67,196.78,256.22,197.56,256.76Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.37,291.55A72.27,72.27,0,0,1,146,221.39a52.81,52.81,0,0,1,7,1.17,70.45,70.45,0,0,0-66.7,69c-.46,23,10.81,46.53,30.14,62.83,15.15,12.77,35.28,21.24,57.4,24.28l-1.42.19q-3,.35-6,.51c-19.66-3.82-37.45-11.92-51.22-23.53C95.43,339.2,83.91,315.15,84.37,291.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.45,359.68c0-.17,0-.33-.07-.5A26.58,26.58,0,0,0,171.83,337a84.22,84.22,0,0,1-27.59-10.57c-6-3.65-11.73-8.12-18.5-10.1a30.17,30.17,0,0,0-19.93,1.16c5.68-6,15.43-8.6,23.22-5.9-5.39-8.25-10.14-17.14-12-26.82s-.54-20.31,5.3-28.25a28.43,28.43,0,0,1,43.88-2.35c5.78,6.33,9,15.23,12.83,22.91,2.73,5.52,5.55,11.16,10,15.37,6.78,6.34,16.53,8.63,23.57,14.7,8,6.88,11.41,17.88,11.45,28.42a83.91,83.91,0,0,1-3.09,21,80,80,0,0,1-28.84,17.63A31.18,31.18,0,0,0,193.45,359.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.2,352c-1,4.1-1.23,11.5-1.23,11.5l-2.73-1a7,7,0,0,0-7.58,1.73l-.13.14a2.76,2.76,0,0,1-3.8.17h0a2.74,2.74,0,0,1-.93-2l-.37-11.61Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.67,395.13c5.66,6.05,16.08,11.35,23.65,6.18l-.85,1.93c-7.57,5.16-18-.13-23.65-6.18s-2-10.25-7.08-15.62a18.63,18.63,0,0,1-4.41-6.55c.23-.57.45-1.33.71-2.19a23.34,23.34,0,0,0,4.55,6.81C206.68,384.88,203,389.07,208.67,395.13Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.83,366.37a10.91,10.91,0,0,0,1.78-4.13,2.41,2.41,0,0,1,1.12-1.68l.07,1.95a2.74,2.74,0,0,0,.93,2,2.76,2.76,0,0,0,3.8-.17l.13-.14a7,7,0,0,1,7.58-1.73L218,363.5a2.12,2.12,0,0,1,1.38,2c-.18,7.93,3.53,18.48,7.42,24.27,4,1.66,7.45,7.11,5.69,11.1l-.18.4c-7.57,5.17-18-.13-23.65-6.18s-2-10.25-7.08-15.62A23.34,23.34,0,0,1,197,372.7,25.18,25.18,0,0,1,199.83,366.37Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.83,366.37a10.91,10.91,0,0,0,1.78-4.13,2.41,2.41,0,0,1,1.12-1.68l.07,1.95a2.74,2.74,0,0,0,.93,2,2.76,2.76,0,0,0,3.8-.17l.13-.14a7,7,0,0,1,7.58-1.73L218,363.5a2.12,2.12,0,0,1,1.38,2c-.18,7.93,3.53,18.48,7.42,24.27,4,1.66,7.45,7.11,5.69,11.1l-.18.4c-7.57,5.17-18-.13-23.65-6.18s-2-10.25-7.08-15.62A23.34,23.34,0,0,1,197,372.7,25.18,25.18,0,0,1,199.83,366.37Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.83,366.37a10.91,10.91,0,0,0,1.78-4.13,2.41,2.41,0,0,1,1.12-1.68l.07,1.95a2.74,2.74,0,0,0,.93,2,2.76,2.76,0,0,0,3.8-.17l.13-.14a7,7,0,0,1,7.58-1.73L218,363.5a2.12,2.12,0,0,1,1.38,2c-.18,7.93,3.53,18.48,7.42,24.27,4,1.66,7.45,7.11,5.69,11.1l-.18.4c-7.57,5.17-18-.13-23.65-6.18s-2-10.25-7.08-15.62A23.34,23.34,0,0,1,197,372.7,25.18,25.18,0,0,1,199.83,366.37Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.91,377.83a1,1,0,0,1-1.29-.43,1,1,0,0,1,.4-1.28,11,11,0,0,1,10.87,0c.17.63.35,1.25.54,1.87C218.22,376.37,215,375.78,210.91,377.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.51,373.54a1,1,0,0,1-.89-1.72,11.64,11.64,0,0,1,11.32.09q.17,1,.39,1.95C217,372.12,213.7,371.42,209.51,373.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.44,382.1a1,1,0,0,1-1.29-.43,1,1,0,0,1,.4-1.28,11,11,0,0,1,10.64-.11q.36,1,.75,2C219.74,380.64,216.49,380.05,212.44,382.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.81,389.81c4,1.66,7.45,7.11,5.69,11.1l-.18.4c-7.46,5.09-17.67,0-23.39-5.92C213.7,386.05,223.66,388.38,226.81,389.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.11,386.27a1,1,0,0,1-.89-1.71,11,11,0,0,1,10.66-.1c.34.74.69,1.45,1,2.13C221.62,384.85,218.3,384.16,214.11,386.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.1,375.06c.71,4.17,3.51,11,3.51,11l-2.91.16a7.05,7.05,0,0,0-6.24,4.64l-.07.18a2.75,2.75,0,0,1-3.39,1.69h0a2.75,2.75,0,0,1-1.66-1.44l-5-10.47Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.88,418.79c7.62,3.25,19.29,3.89,24.13-3.89V417c-4.84,7.79-16.51,7.15-24.13,3.9s-6-8.58-12.79-11.44a18.62,18.62,0,0,1-6.67-4.21c0-.62-.13-1.39-.23-2.29a23.19,23.19,0,0,0,6.9,4.4C232.92,410.21,231.25,415.53,238.88,418.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.19,396a10.94,10.94,0,0,0,0-4.49,2.38,2.38,0,0,1,.34-2l.85,1.75a2.74,2.74,0,0,0,5-.25l.07-.18a7.05,7.05,0,0,1,6.24-4.64l3-.16a2.12,2.12,0,0,1,2.08,1.31c3,7.33,10.69,15.48,16.59,19.21,4.32-.1,9.68,3.5,9.68,7.86v.44c-4.84,7.78-16.51,7.14-24.13,3.89s-6-8.58-12.79-11.43a23.19,23.19,0,0,1-6.9-4.4A24.4,24.4,0,0,1,219.19,396Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.19,396a10.94,10.94,0,0,0,0-4.49,2.38,2.38,0,0,1,.34-2l.85,1.75a2.74,2.74,0,0,0,5-.25l.07-.18a7.05,7.05,0,0,1,6.24-4.64l3-.16a2.12,2.12,0,0,1,2.08,1.31c3,7.33,10.69,15.48,16.59,19.21,4.32-.1,9.68,3.5,9.68,7.86v.44c-4.84,7.78-16.51,7.14-24.13,3.89s-6-8.58-12.79-11.43a23.19,23.19,0,0,1-6.9-4.4A24.4,24.4,0,0,1,219.19,396Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.19,396a10.94,10.94,0,0,0,0-4.49,2.38,2.38,0,0,1,.34-2l.85,1.75a2.74,2.74,0,0,0,5-.25l.07-.18a7.05,7.05,0,0,1,6.24-4.64l3-.16a2.12,2.12,0,0,1,2.08,1.31c3,7.33,10.69,15.48,16.59,19.21,4.32-.1,9.68,3.5,9.68,7.86v.44c-4.84,7.78-16.51,7.14-24.13,3.89s-6-8.58-12.79-11.43a23.19,23.19,0,0,1-6.9-4.4A24.4,24.4,0,0,1,219.19,396Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.94,402.06a1,1,0,0,1-1.5-1.21,11,11,0,0,1,9.95-4.37c.41.5.82,1,1.25,1.49A10.65,10.65,0,0,0,233.94,402.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.94,398.7a1,1,0,0,1-1.35.12,1,1,0,0,1-.16-1.34A11.62,11.62,0,0,1,239.82,393q.54.83,1.14,1.62C237.24,394.36,233.91,395.07,230.94,398.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.07,405.35a1,1,0,0,1-1.35.12.94.94,0,0,1-.16-1.33,11,11,0,0,1,9.69-4.39c.49.52,1,1,1.49,1.51A10.62,10.62,0,0,0,237.07,405.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.33,406.6c4.32-.1,9.68,3.5,9.68,7.86v.44c-4.77,7.67-16.16,7.16-23.78,4C239.81,408.45,249.87,406.57,253.33,406.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.28,408.49a1,1,0,0,1-1.51-1.21,11,11,0,0,1,9.72-4.39c.61.54,1.21,1.05,1.82,1.53C246.58,404.16,243.26,404.87,240.28,408.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.32,275.92l38.15,21.25a18.92,18.92,0,0,1,9.39,20L226.45,357l6.07,19.29c-5.24,7-17.26,7.39-17.26,7.39-6.71-13.46-11.64-19.18-15.45-30.45s-6.35-19.06-6.35-19.06l-31.68-8.66a37.52,37.52,0,0,1-27.46-31.94c-.54-4.79-.56-8.06-.56-8.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,286.64a18.06,18.06,0,0,1-4.27,11.62l26.92,16.86a19.31,19.31,0,0,1,8.24,10.74L226.45,357l-8.59-34.7a15.73,15.73,0,0,0-7-9.6L186,297.35C188.54,291,186,286.64,186,286.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.81,234.68l5.34,5.18c5.48-7,12.84-11.73,19.28-21.55,1.86-2.35,1.66-7,2.92-9.42,1-1.88,2.72-4.69,3.44-6.27a1.05,1.05,0,0,1,1.53-.46c1.84,1.33.87,4.51-.09,7.85-1.13,3.92,4.78-1.39,5.57-2.29,3.75-3.48,7-12,9.52-11.17s.53,5.1.53,5.1c2.35.5,1.46,4.25,1.46,4.25,1.4,2.45,1,6.24-1.85,9.75-2.08,2.56-7.69,6.06-10.6,7.78a9.58,9.58,0,0,0-3,2.87L230.5,253.53a11.12,11.12,0,0,1-15.88,2.7l-10-7.45Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.4,226c-3.37,4-9.32,6.51-13.11,12.86l-4.81-4.46c-7.76-7.76-21.54-24.24-31.69-23.79v23.19a220.66,220.66,0,0,0,20.88,16.32L216,258a10.71,10.71,0,0,0,15.24-3.27l12.87-21.3A11.83,11.83,0,0,1,233.4,226Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.4,226c-3.37,4-9.32,6.51-13.11,12.86l-4.81-4.46c-7.76-7.76-21.54-24.24-31.69-23.79v23.19a220.66,220.66,0,0,0,20.88,16.32L216,258a10.71,10.71,0,0,0,15.24-3.27l12.87-21.3A11.83,11.83,0,0,1,233.4,226Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.15,288.5c6.76,6.5,39.27,7.7,55.86-8.09-1.59-11.15-1.06-23.09,0-34.9s8-32.47-5.22-34.87c-17.6-3.44-29.1-3.17-40.87,3.46C130.36,235,132.08,266.34,133.15,288.5Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.15,288.5c6.76,6.5,39.27,7.7,55.86-8.09-1.59-11.15-1.06-23.09,0-34.9s8-32.47-5.22-34.87c-17.6-3.44-29.1-3.17-40.87,3.46C130.36,235,132.08,266.34,133.15,288.5Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.15,288.5c6.76,6.5,39.27,7.7,55.86-8.09-1.59-11.15-1.06-23.09,0-34.9s8-32.47-5.22-34.87c-17.6-3.44-29.1-3.17-40.87,3.46C130.36,235,132.08,266.34,133.15,288.5Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.39,302.52a1.48,1.48,0,0,0,.05.51,0,0,0,0,1,0,0,1.2,1.2,0,0,0,.2.39l0,.05a2,2,0,0,0,.35.38l0,0a2.58,2.58,0,0,0,.51.37l27.92,16.23a5.23,5.23,0,0,0,.8.35l.31.09.41.1a3.86,3.86,0,0,0,.49.09h.12a5.32,5.32,0,0,0,.69,0h.1a5.07,5.07,0,0,0,.68,0h.1a4.64,4.64,0,0,0,.65-.11l.12,0a5.18,5.18,0,0,0,.56-.17l.1,0a5.07,5.07,0,0,0,.62-.29l46.06-26.6a3.78,3.78,0,0,0,.53-.37,1.79,1.79,0,0,1,.13-.14,2.91,2.91,0,0,0,.24-.27c0-.06.06-.12.09-.17a1.66,1.66,0,0,0,.13-.27,1.06,1.06,0,0,0,0-.19,2.17,2.17,0,0,0,0-.25v1.63a2.34,2.34,0,0,1,0,.26,1.29,1.29,0,0,1,0,.19,1.58,1.58,0,0,1-.13.26.91.91,0,0,1-.09.17,2,2,0,0,1-.24.27,1.79,1.79,0,0,1-.13.14,3.1,3.1,0,0,1-.53.37l-46.06,26.6a3.92,3.92,0,0,1-.62.29l-.1,0a5.22,5.22,0,0,1-.56.18l-.12,0c-.21.05-.43.09-.65.12h-.1l-.68,0h-.1l-.69,0-.12,0-.49-.08-.41-.1-.31-.1a5.23,5.23,0,0,1-.8-.35L160.55,305.9a2.55,2.55,0,0,1-.51-.36l0,0a2,2,0,0,1-.35-.38l0,0a1.45,1.45,0,0,1-.2-.39s0,0,0,0a1.54,1.54,0,0,1,0-.37h0v-1.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.39,302.52a1.48,1.48,0,0,0,.05.51,0,0,0,0,1,0,0,1.2,1.2,0,0,0,.2.39l0,.05a2,2,0,0,0,.35.38l0,0a2.58,2.58,0,0,0,.51.37l27.92,16.23a5.23,5.23,0,0,0,.8.35l.31.09.41.1a3.86,3.86,0,0,0,.49.09h.12a5.32,5.32,0,0,0,.69,0h.1a5.07,5.07,0,0,0,.68,0h.1a4.64,4.64,0,0,0,.65-.11l.12,0a5.18,5.18,0,0,0,.56-.17l.1,0a5.07,5.07,0,0,0,.62-.29l46.06-26.6a3.78,3.78,0,0,0,.53-.37,1.79,1.79,0,0,1,.13-.14,2.91,2.91,0,0,0,.24-.27c0-.06.06-.12.09-.17a1.66,1.66,0,0,0,.13-.27,1.06,1.06,0,0,0,0-.19,2.17,2.17,0,0,0,0-.25v1.63a2.34,2.34,0,0,1,0,.26,1.29,1.29,0,0,1,0,.19,1.58,1.58,0,0,1-.13.26.91.91,0,0,1-.09.17,2,2,0,0,1-.24.27,1.79,1.79,0,0,1-.13.14,3.1,3.1,0,0,1-.53.37l-46.06,26.6a3.92,3.92,0,0,1-.62.29l-.1,0a5.22,5.22,0,0,1-.56.18l-.12,0c-.21.05-.43.09-.65.12h-.1l-.68,0h-.1l-.69,0-.12,0-.49-.08-.41-.1-.31-.1a5.23,5.23,0,0,1-.8-.35L160.55,305.9a2.55,2.55,0,0,1-.51-.36l0,0a2,2,0,0,1-.35-.38l0,0a1.45,1.45,0,0,1-.2-.39s0,0,0,0a1.54,1.54,0,0,1,0-.37h0v-1.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.4,292.68a1.66,1.66,0,0,1-.13.27c0,.05-.05.11-.09.17a2.91,2.91,0,0,1-.24.27,1.79,1.79,0,0,0-.13.14,3.78,3.78,0,0,1-.53.37l-46.06,26.6a5.07,5.07,0,0,1-.62.29l-.1,0a5.18,5.18,0,0,1-.56.17l-.12,0a4.64,4.64,0,0,1-.65.11h-.1a5.07,5.07,0,0,1-.68,0h-.1a5.32,5.32,0,0,1-.69,0h-.12A3.86,3.86,0,0,1,190,321l-.41-.1-.31-.09a5.23,5.23,0,0,1-.8-.35l-27.92-16.23a2.58,2.58,0,0,1-.51-.37l0,0a2,2,0,0,1-.35-.38l0-.05a1.2,1.2,0,0,1-.2-.39,0,0,0,0,0,0,0,1.48,1.48,0,0,1-.05-.51,2.06,2.06,0,0,1,1.19-1.57l46.06-26.6a6.29,6.29,0,0,1,5.73,0l27.92,16.23a2,2,0,0,1,1.19,1.66,2.17,2.17,0,0,1,0,.25A1.06,1.06,0,0,1,241.4,292.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57,292.23l-44.75,25.84-.18.09-.1,0a2.37,2.37,0,0,1-.35.1l-.24,0-.17,0-.44,0h0l-.46,0-.29-.05-.36-.1a1.2,1.2,0,0,1-.31-.13l-14.4-8.36L221.71,283Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.29,318.38h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,285.13l8.42,4.95a.85.85,0,0,1,0,1.47l-12.59,7.27a1.39,1.39,0,0,1-1.41,0L181,293.86a.85.85,0,0,1,0-1.47l12.58-7.27A1.39,1.39,0,0,1,195,285.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.57,292.23l-44.75,25.84-.18.09-.1,0a2.37,2.37,0,0,1-.35.1l-.24,0-.17,0-.44,0h0l-.46,0-.29-.05-.36-.1a1.2,1.2,0,0,1-.31-.13l-14.4-8.36L221.71,283Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,285.13l8.42,4.95a.85.85,0,0,1,0,1.47l-12.59,7.27a1.39,1.39,0,0,1-1.41,0L181,293.86a.85.85,0,0,1,0-1.47l12.58-7.27A1.39,1.39,0,0,1,195,285.13Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.62,318.84l4.77-30.32a5.58,5.58,0,0,1,2.72-4l46.38-27a1.38,1.38,0,0,1,1.23-.08h0l1.1.55-.37.14a1.49,1.49,0,0,1,.12.82l-4.77,30.32a5.56,5.56,0,0,1-2.72,4l-46.38,27a1.25,1.25,0,0,1-.3.12l0,.45-1.07-.53h0A1.38,1.38,0,0,1,191.62,318.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.62,318.84l4.77-30.32a5.58,5.58,0,0,1,2.72-4l46.38-27a1.38,1.38,0,0,1,1.23-.08h0l1.1.55-.37.14a1.49,1.49,0,0,1,.12.82l-4.77,30.32a5.56,5.56,0,0,1-2.72,4l-46.38,27a1.25,1.25,0,0,1-.3.12l0,.45-1.07-.53h0A1.38,1.38,0,0,1,191.62,318.84Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,285l46.38-27a1.4,1.4,0,0,1,2.09,1.42l-4.77,30.33a5.62,5.62,0,0,1-2.71,4l-46.39,27a1.4,1.4,0,0,1-2.08-1.43L197.32,289A5.59,5.59,0,0,1,200,285Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.52,285.8a10.22,10.22,0,0,0-4.6,6.63c-.31,2.37,1.26,3.24,3.5,1.95a10.27,10.27,0,0,0,4.61-6.63C226.33,285.38,224.76,284.51,222.52,285.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,251.58l-4.19,14.36,25.59,18.18,8.61,3.62a13.53,13.53,0,0,1,5.7,4.53l7,9.71c.79,1.63-2.87,4.28-4.63,4.73h0a6.29,6.29,0,0,1-5.81-1.45l-5.42-5-1.5-.52a22.78,22.78,0,0,1-10.88-8.17h0l-30-11.65a11.46,11.46,0,0,1-6.93-13.68l5-18.51Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.47,277.79l-16.69-11.85,3.9-11.41,7.42-22.18s.24-19.44-8-18.84-12.44,5.38-18.77,34.21l-3.76,17.21a14.26,14.26,0,0,0,9.31,16.52l21.24,7.29A10.72,10.72,0,0,1,157.47,277.79Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.47,277.79l-16.69-11.85,3.9-11.41,7.42-22.18s.24-19.44-8-18.84-12.44,5.38-18.77,34.21l-3.76,17.21a14.26,14.26,0,0,0,9.31,16.52l21.24,7.29A10.72,10.72,0,0,1,157.47,277.79Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.15,203c-2.44-4.53-4.56-9.23-7-13.76-1.59-2.95-3.23-6-3.32-9.38a11,11,0,0,1,5.17-9.46c1.19-6,6.05-11.18,12.1-12,3.78-.49,7.57.5,11.37.85s8-.13,10.66-2.88a6.69,6.69,0,0,1,1.3,4,6.47,6.47,0,0,1-1.25,3.92,4.85,4.85,0,0,1,3.43.25,2.88,2.88,0,0,1,1,2.95,6,6,0,0,1-1.63,2.84,4.67,4.67,0,0,1,2.46,4.15,6.31,6.31,0,0,1-2.28,4.29c-2.43,2.08-5.82,2.49-9,2.81L168,183.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.47,223.07h0a11.72,11.72,0,0,0,0-9.09V201.82L161.42,193l-.36,13.49C164,215,174.37,218.56,177.47,223.07Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.21,205.73c2.68,1.29,6,2.6,8.26,3.44v-7.35L161.42,193C161.55,201,164.76,203.58,169.21,205.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.7,212.41c.45,3.71,3.53,9,10,14.33,0,0,2.4-5.57,5.47-6a38.29,38.29,0,0,1,4.31,2.29c-3.1-4.51-13.49-8-16.41-16.61C160,207.5,159,210,157.7,212.41Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.47,223.07a11.72,11.72,0,0,0,0-9.09v-4.81c2.93,3,6.83,7.55,7.79,12.41-1.56-1.41-3.87-4.59-4.75-2.82C179.43,222.18,177.47,223.07,177.47,223.07Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.7,212.41c.45,3.71,3.53,9,10,14.33,0,0,2.4-5.57,5.47-6a38.29,38.29,0,0,1,4.31,2.29c-3.1-4.51-13.49-8-16.41-16.61C160,207.5,159,210,157.7,212.41Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.47,223.07a11.72,11.72,0,0,0,0-9.09v-4.81c2.93,3,6.83,7.55,7.79,12.41-1.56-1.41-3.87-4.59-4.75-2.82C179.43,222.18,177.47,223.07,177.47,223.07Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.48,170.75a142.55,142.55,0,0,1-.77,28.1A8.16,8.16,0,0,1,181.4,206a107.81,107.81,0,0,1-11.62-2.52,10.94,10.94,0,0,1-7.77-8l-.59-2.46c-1.25,1.88-4,2.29-6.07,1.42a6.78,6.78,0,0,1-3.85-5.23,6.23,6.23,0,0,1,.29-3.31,4.32,4.32,0,0,1,2.22-2.4,4.84,4.84,0,0,1,5.35,1.52,10.43,10.43,0,0,1,2.16,5.46,16.86,16.86,0,0,0,4.22-12.14,6,6,0,0,0,3.88-2,5.31,5.31,0,0,0,1-4C176.94,175.53,185.59,174.67,191.48,170.75Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.28 184.17 185.85 190.92 180.74 192.73 180.28 184.17",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.06,196.08l4.3,1.32a2.64,2.64,0,0,1-2.9,1.33A2.38,2.38,0,0,1,176.06,196.08Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.06,196.08l4.3,1.32a2.64,2.64,0,0,1-2.9,1.33A2.38,2.38,0,0,1,176.06,196.08Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.87,198.65a2.36,2.36,0,0,1-1.41.08,2.14,2.14,0,0,1-1.39-1.94,2.54,2.54,0,0,1,1.66.31A2.5,2.5,0,0,1,178.87,198.65Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.7,185.65a1.53,1.53,0,1,0,1.44-1.61A1.52,1.52,0,0,0,172.7,185.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,184.47a1.53,1.53,0,1,0,1.45-1.61A1.54,1.54,0,0,0,185.5,184.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.66,178.31l3.51,2.16a2.15,2.15,0,0,0-.79-2.36A2.56,2.56,0,0,0,186.66,178.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.57,178.83l-3.26,2.52a2.17,2.17,0,0,1,.53-2.43A2.58,2.58,0,0,1,173.57,178.83Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Progress--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.28,222.19c1.26-.73,2.29-.15,2.29,1.3l0,8.09a5,5,0,0,1-2.27,3.94l-70.57,40.74c-1.26.73-2.29.15-2.29-1.3l0-8.09a5,5,0,0,1,2.27-3.94Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M326.28,222.19c1.26-.73,2.29-.15,2.29,1.3l0,8.09a5,5,0,0,1-2.27,3.94l-70.57,40.74c-1.26.73-2.29.15-2.29-1.3l0-8.09a5,5,0,0,1,2.27-3.94Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.28,222.19c1.26-.73,2.29-.15,2.29,1.3l0,8.09a5,5,0,0,1-2.27,3.94l-70.57,40.74c-1.26.73-2.29.15-2.29-1.3l0-8.09a5,5,0,0,1,2.27-3.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.74,237c.47-.27.84-.05.84.48v3a1.84,1.84,0,0,1-.83,1.44l-73.48,42.67c-.46.27-.84.06-.84-.48v-3a1.83,1.83,0,0,1,.83-1.45Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.74,237c.47-.27.84-.05.84.48v3a1.84,1.84,0,0,1-.83,1.44l-73.48,42.67c-.46.27-.84.06-.84-.48v-3a1.83,1.83,0,0,1,.83-1.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.74,244.16c.47-.27.84-.06.84.48v3a1.86,1.86,0,0,1-.83,1.45l-73.48,42.67c-.46.27-.84,0-.84-.48v-3a1.82,1.82,0,0,1,.83-1.44Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.74,244.16c.47-.27.84-.06.84.48v3a1.86,1.86,0,0,1-.83,1.45l-73.48,42.67c-.46.27-.84,0-.84-.48v-3a1.82,1.82,0,0,1,.83-1.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.93,241.91V246a5.84,5.84,0,0,1-3,5.15c-1.89,1.09-3,.5-3-1.68v-4.07l1.81-1v4c0,1.26.46,1.5,1.22,1.06a2.57,2.57,0,0,0,1.2-2.46v-4Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.08,239.52c1.74-1,2.83-.6,2.84,1.07a5.26,5.26,0,0,1-2.83,4.35l-1.11.64v1.92l-1.81,1.05,0-7.35Zm-.1,3.84a2,2,0,0,0,1.11-1.71c0-.69-.37-.87-1.12-.43l-1,.58v2.14l1-.58",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.6 236.33 277.61 242.02 280.66 240.26 280.66 241.91 275.81 244.71 275.79 237.37 277.6 236.33",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.48,232.2c2-1.18,3.56-.43,3.56,1.77a7.28,7.28,0,0,1-3.53,5.87c-2.05,1.18-3.56.43-3.57-1.77A7.29,7.29,0,0,1,284.48,232.2Zm0,5.92a3.7,3.7,0,0,0,1.71-3.09c0-1.27-.76-1.66-1.72-1.1a3.72,3.72,0,0,0-1.72,3.09c0,1.26.76,1.66,1.73,1.1",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.73,227.59l2.85,5.71-1.89,1.09-.5-1.15-2.7,1.57-.5,1.72-1.84,1.06,2.8-9ZM291,233l1.63-.94-.82-1.89L291,233",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.09,223.92c2.12-1.22,3.57-.64,3.58,1.61a6.91,6.91,0,0,1-3.56,5.73l-3,1.74,0-7.34Zm-.06,5.72a3.57,3.57,0,0,0,1.81-3.06c0-1.27-.73-1.59-1.82-1l-1.14.66v4l1.14-.66",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.42 220.27 305.44 227.61 303.63 228.65 303.61 221.31 305.42 220.27",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.79 216.01 312.81 223.35 311.31 224.22 308.49 221.92 308.5 225.84 306.73 226.86 306.7 219.52 308.19 218.66 311.02 220.95 311.01 217.04 312.79 216.01",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.3,213.26c1.19-.69,2.16-.78,2.79-.27l-1.15,1.86a1.36,1.36,0,0,0-1.55.08,3.73,3.73,0,0,0-1.82,3.15c0,1.23.74,1.68,1.81,1a3.75,3.75,0,0,0,1-.8v-2l1.59-.92v3a8.91,8.91,0,0,1-2.68,2.48c-2,1.18-3.53.45-3.53-1.78A7.16,7.16,0,0,1,317.3,213.26Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M267.93,241.91V246a5.84,5.84,0,0,1-3,5.15c-1.89,1.09-3,.5-3-1.68v-4.07l1.81-1v4c0,1.26.46,1.5,1.22,1.06a2.57,2.57,0,0,0,1.2-2.46v-4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M272.08,239.52c1.74-1,2.83-.6,2.84,1.07a5.26,5.26,0,0,1-2.83,4.35l-1.11.64v1.92l-1.81,1.05,0-7.35Zm-.1,3.84a2,2,0,0,0,1.11-1.71c0-.69-.37-.87-1.12-.43l-1,.58v2.14l1-.58"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "277.6 236.33 277.61 242.02 280.66 240.26 280.66 241.91 275.81 244.71 275.79 237.37 277.6 236.33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M284.48,232.2c2-1.18,3.56-.43,3.56,1.77a7.28,7.28,0,0,1-3.53,5.87c-2.05,1.18-3.56.43-3.57-1.77A7.29,7.29,0,0,1,284.48,232.2Zm0,5.92a3.7,3.7,0,0,0,1.71-3.09c0-1.27-.76-1.66-1.72-1.1a3.72,3.72,0,0,0-1.72,3.09c0,1.26.76,1.66,1.73,1.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M292.73,227.59l2.85,5.71-1.89,1.09-.5-1.15-2.7,1.57-.5,1.72-1.84,1.06,2.8-9ZM291,233l1.63-.94-.82-1.89L291,233"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M299.09,223.92c2.12-1.22,3.57-.64,3.58,1.61a6.91,6.91,0,0,1-3.56,5.73l-3,1.74,0-7.34Zm-.06,5.72a3.57,3.57,0,0,0,1.81-3.06c0-1.27-.73-1.59-1.82-1l-1.14.66v4l1.14-.66"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "305.42 220.27 305.44 227.61 303.63 228.65 303.61 221.31 305.42 220.27"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "312.79 216.01 312.81 223.35 311.31 224.22 308.49 221.92 308.5 225.84 306.73 226.86 306.7 219.52 308.19 218.66 311.02 220.95 311.01 217.04 312.79 216.01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M317.3,213.26c1.19-.69,2.16-.78,2.79-.27l-1.15,1.86a1.36,1.36,0,0,0-1.55.08,3.73,3.73,0,0,0-1.82,3.15c0,1.23.74,1.68,1.81,1a3.75,3.75,0,0,0,1-.8v-2l1.59-.92v3a8.91,8.91,0,0,1-2.68,2.48c-2,1.18-3.53.45-3.53-1.78A7.16,7.16,0,0,1,317.3,213.26Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.93,241.91V246a5.84,5.84,0,0,1-3,5.15c-1.89,1.09-3,.5-3-1.68v-4.07l1.81-1v4c0,1.26.46,1.5,1.22,1.06a2.57,2.57,0,0,0,1.2-2.46v-4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.08,239.52c1.74-1,2.83-.6,2.84,1.07a5.26,5.26,0,0,1-2.83,4.35l-1.11.64v1.92l-1.81,1.05,0-7.35Zm-.1,3.84a2,2,0,0,0,1.11-1.71c0-.69-.37-.87-1.12-.43l-1,.58v2.14l1-.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.6 236.33 277.61 242.02 280.66 240.26 280.66 241.91 275.81 244.71 275.79 237.37 277.6 236.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.48,232.2c2-1.18,3.56-.43,3.56,1.77a7.28,7.28,0,0,1-3.53,5.87c-2.05,1.18-3.56.43-3.57-1.77A7.29,7.29,0,0,1,284.48,232.2Zm0,5.92a3.7,3.7,0,0,0,1.71-3.09c0-1.27-.76-1.66-1.72-1.1a3.72,3.72,0,0,0-1.72,3.09c0,1.26.76,1.66,1.73,1.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.73,227.59l2.85,5.71-1.89,1.09-.5-1.15-2.7,1.57-.5,1.72-1.84,1.06,2.8-9ZM291,233l1.63-.94-.82-1.89L291,233",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.09,223.92c2.12-1.22,3.57-.64,3.58,1.61a6.91,6.91,0,0,1-3.56,5.73l-3,1.74,0-7.34Zm-.06,5.72a3.57,3.57,0,0,0,1.81-3.06c0-1.27-.73-1.59-1.82-1l-1.14.66v4l1.14-.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.42 220.27 305.44 227.61 303.63 228.65 303.61 221.31 305.42 220.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.79 216.01 312.81 223.35 311.31 224.22 308.49 221.92 308.5 225.84 306.73 226.86 306.7 219.52 308.19 218.66 311.02 220.95 311.01 217.04 312.79 216.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.3,213.26c1.19-.69,2.16-.78,2.79-.27l-1.15,1.86a1.36,1.36,0,0,0-1.55.08,3.73,3.73,0,0,0-1.82,3.15c0,1.23.74,1.68,1.81,1a3.75,3.75,0,0,0,1-.8v-2l1.59-.92v3a8.91,8.91,0,0,1-2.68,2.48c-2,1.18-3.53.45-3.53-1.78A7.16,7.16,0,0,1,317.3,213.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "283.01 249.91 283.03 257.25 281.22 258.29 281.2 252.56 280.02 253.24 280.01 251.64 283.01 249.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.79,247.59c1.62-.94,2.81-.23,2.81,2.19a6.23,6.23,0,0,1-2.79,5.44c-1.63.94-2.83.23-2.83-2.19A6.23,6.23,0,0,1,286.79,247.59Zm0,5.93c.58-.33,1-1.15,1-2.69s-.42-1.88-1-1.55-1,1.16-1,2.7.42,1.87,1,1.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,244c1.63-.95,2.82-.24,2.82,2.19a6.22,6.22,0,0,1-2.8,5.44c-1.63.94-2.82.23-2.83-2.19A6.24,6.24,0,0,1,293,244Zm0,5.93c.58-.33,1-1.15,1-2.7s-.43-1.87-1-1.53-1,1.15-1,2.69.42,1.87,1,1.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.65,242.25a3.49,3.49,0,0,1-1.64,3c-.94.54-1.63.18-1.64-1.09a3.49,3.49,0,0,1,1.63-3C299,240.61,299.64,241,299.65,242.25Zm-2.18,1.26c0,.74.25.89.53.73a1.45,1.45,0,0,0,.54-1.35c0-.75-.23-.91-.54-.73a1.48,1.48,0,0,0-.53,1.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.78 239.07 303.09 238.31 298.75 248.17 297.44 248.93 301.78 239.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.52,242c.94-.55,1.64-.19,1.65,1.09a3.51,3.51,0,0,1-1.64,3c-.95.54-1.64.18-1.64-1.09A3.46,3.46,0,0,1,302.52,242Zm0,3.07c.3-.17.53-.6.53-1.34s-.24-.91-.54-.73a1.46,1.46,0,0,0-.54,1.35c0,.74.25.9.55.72",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.06,85.7l-28.79,16.51a5.67,5.67,0,0,0-2.82,4.87v21a5.55,5.55,0,0,0,8.49,4.57l5-2.86.45.73.07.07h0l0,0h0c.82.55,2.27,1.32,2.6,1.49v0a.31.31,0,0,0,.38-.19l1.84-5.22h0l18.37-10.5a5.62,5.62,0,0,0,2.83-4.88v-21C203.54,86.21,197.58,84.25,195.06,85.7Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.28,105.62h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.39,130.47l.07.07h0l0,0h0c.82.55,2.27,1.32,2.6,1.49v0a.29.29,0,0,1-.18-.13L178.15,129l.36-.2h0l-1.57.9Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.77,107.51a5.71,5.71,0,0,1,1.5-1.89h0a4.81,4.81,0,0,1,.68-.47l28.78-16.51a1.87,1.87,0,0,1,2.8,1.62c0-4.05-6-6-8.48-4.56l-28.79,16.51a5.6,5.6,0,0,0-2.09,2.12Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.13,131V110a4.91,4.91,0,0,1,.05-.67,5.72,5.72,0,0,1,.59-1.85l-5.59-3.18a5.57,5.57,0,0,0-.73,2.75v21a5.55,5.55,0,0,0,8.49,4.57A1.88,1.88,0,0,1,169.13,131Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.54,96.22a1.18,1.18,0,0,1,1.16-.12c.65.37.65,1.57,0,2.68l-12.55,21.74a3.42,3.42,0,0,1-1.16,1.22,1.18,1.18,0,0,1-1.17.12l-5.52-3.14c-.64-.37-.65-1.56,0-2.67a3.28,3.28,0,0,1,1.15-1.23,1.2,1.2,0,0,1,1.17-.12l4.35,2.49,11.4-19.75A3.42,3.42,0,0,1,196.54,96.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.78,66.92a146.53,146.53,0,0,0,21.57,15c1.48.85,3,1.69,4.49,2.5l.49.27c4.29,2.48,6.31,6,5,9.47a8,8,0,0,0-.46,4c.46,3.18,2.83,6.09,6.73,8.34l-5.74,3.37a14.72,14.72,0,0,1-13.19,0,42.28,42.28,0,0,0,8.7-4c-.57.25-1.16.49-1.75.73a17.19,17.19,0,0,1-13.69-.82c-.18-.1-.35-.21-.51-.32a76.05,76.05,0,0,0,11.66-3.71c-5.92,2.22-13.51,1.59-18.31-1.18a11.67,11.67,0,0,1-1.35-.89c-1-.74-1.82-1.4-2.3-1.8a78.66,78.66,0,0,0,15.43-.41h-.2a37.51,37.51,0,0,1-17.86-4.46c-3.63-2.1-6.25-4.8-7.37-7.85l-.15-.45a80.36,80.36,0,0,0,22.56,7.16,97.45,97.45,0,0,1-16-6.6q-.33-.16-.66-.36c-5.13-3-6.84-7.41-4.33-11.37A83.82,83.82,0,0,0,287,79.91a111,111,0,0,0,13.71,6.61c-1.37-.71-2.71-1.43-4-2.18a75.27,75.27,0,0,1-13.45-9.79C280.6,72.1,281.23,68.93,284.78,66.92Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M284.78,66.92a146.53,146.53,0,0,0,21.57,15c1.48.85,3,1.69,4.49,2.5l.49.27c4.29,2.48,6.31,6,5,9.47a8,8,0,0,0-.46,4c.46,3.18,2.83,6.09,6.73,8.34l-5.74,3.37a14.72,14.72,0,0,1-13.19,0,42.28,42.28,0,0,0,8.7-4c-.57.25-1.16.49-1.75.73a17.19,17.19,0,0,1-13.69-.82c-.18-.1-.35-.21-.51-.32a76.05,76.05,0,0,0,11.66-3.71c-5.92,2.22-13.51,1.59-18.31-1.18a11.67,11.67,0,0,1-1.35-.89c-1-.74-1.82-1.4-2.3-1.8a78.66,78.66,0,0,0,15.43-.41h-.2a37.51,37.51,0,0,1-17.86-4.46c-3.63-2.1-6.25-4.8-7.37-7.85l-.15-.45a80.36,80.36,0,0,0,22.56,7.16,97.45,97.45,0,0,1-16-6.6q-.33-.16-.66-.36c-5.13-3-6.84-7.41-4.33-11.37A83.82,83.82,0,0,0,287,79.91a111,111,0,0,0,13.71,6.61c-1.37-.71-2.71-1.43-4-2.18a75.27,75.27,0,0,1-13.45-9.79C280.6,72.1,281.23,68.93,284.78,66.92Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.78,66.92a146.53,146.53,0,0,0,21.57,15c1.48.85,3,1.69,4.49,2.5l.49.27c4.29,2.48,6.31,6,5,9.47a8,8,0,0,0-.46,4c.46,3.18,2.83,6.09,6.73,8.34l-5.74,3.37a14.72,14.72,0,0,1-13.19,0,42.28,42.28,0,0,0,8.7-4c-.57.25-1.16.49-1.75.73a17.19,17.19,0,0,1-13.69-.82c-.18-.1-.35-.21-.51-.32a76.05,76.05,0,0,0,11.66-3.71c-5.92,2.22-13.51,1.59-18.31-1.18a11.67,11.67,0,0,1-1.35-.89c-1-.74-1.82-1.4-2.3-1.8a78.66,78.66,0,0,0,15.43-.41h-.2a37.51,37.51,0,0,1-17.86-4.46c-3.63-2.1-6.25-4.8-7.37-7.85l-.15-.45a80.36,80.36,0,0,0,22.56,7.16,97.45,97.45,0,0,1-16-6.6q-.33-.16-.66-.36c-5.13-3-6.84-7.41-4.33-11.37A83.82,83.82,0,0,0,287,79.91a111,111,0,0,0,13.71,6.61c-1.37-.71-2.71-1.43-4-2.18a75.27,75.27,0,0,1-13.45-9.79C280.6,72.1,281.23,68.93,284.78,66.92Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.92,98.08V96.42A2.12,2.12,0,0,1,329,94.59L343.85,86a1.05,1.05,0,0,1,1.58.91v35.27l-38.08,22v-33l19.51-11.27A2.11,2.11,0,0,0,327.92,98.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.92,98.08V96.42A2.12,2.12,0,0,1,329,94.59L343.85,86a1.05,1.05,0,0,1,1.58.91v35.27l-38.08,22v-33l19.51-11.27A2.11,2.11,0,0,0,327.92,98.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.92,98.08V96.42A2.12,2.12,0,0,1,329,94.59L343.85,86a1.05,1.05,0,0,1,1.58.91v35.27l-38.08,22v-33l19.51-11.27A2.11,2.11,0,0,0,327.92,98.08Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.35 144.69 310.17 113.56 348.25 91.04 345.43 122.17 307.35 144.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.35 144.69 310.17 113.56 348.25 91.04 345.43 122.17 307.35 144.69",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.43 122.17 351.08 92.59 312.99 114.2 307.35 144.16 345.43 122.17",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.43 122.17 351.08 92.59 312.99 114.2 307.35 144.16 345.43 122.17",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.43 122.17 351.08 92.59 312.99 114.2 307.35 144.16 345.43 122.17",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,135.68c-3.53,2.1-9,2.47-13.23,1a105.7,105.7,0,0,1-16.95-7.76q-1.95-1.14-3.78-2.32a84.73,84.73,0,0,0,11.46,7.92,91.39,91.39,0,0,0,11.09,5.42c-7,1.49-14.65.52-19.79-2.45l-.62-.38a60.14,60.14,0,0,1-11.45-9.25,35.84,35.84,0,0,0,12.45,13l-.78-.08a36.25,36.25,0,0,1-13.57-4.24c-4.66-2.69-7.58-6.34-7.77-10.33v-.12a15.63,15.63,0,0,0-.65,8.94c-.7-.28-1.83-.76-3.12-1.32a17,17,0,0,1-1.54-.78c-4.8-2.77-5.9-7.17-2.18-10.54a30.35,30.35,0,0,0-6.22,6.73,6.51,6.51,0,0,1-.61-.33c-3.64-2.1-4.33-5.42-1.46-7.92.4-.35.81-.68,1.24-1a29.76,29.76,0,0,0-6.9,5.06c-3.59-2.11-3.58-5.55,0-7.64l5.77-3.36a32.15,32.15,0,0,0,14.44,3.89,40.3,40.3,0,0,0,6.87-.28,27,27,0,0,1,16.35,2.88c.16.09.32.18.47.28q2.13,1.32,4.33,2.59A187,187,0,0,0,404,135.68Z",
    style: {
      fill: "#62EC83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M404,135.68c-3.53,2.1-9,2.47-13.23,1a105.7,105.7,0,0,1-16.95-7.76q-1.95-1.14-3.78-2.32a84.73,84.73,0,0,0,11.46,7.92,91.39,91.39,0,0,0,11.09,5.42c-7,1.49-14.65.52-19.79-2.45l-.62-.38a60.14,60.14,0,0,1-11.45-9.25,35.84,35.84,0,0,0,12.45,13l-.78-.08a36.25,36.25,0,0,1-13.57-4.24c-4.66-2.69-7.58-6.34-7.77-10.33v-.12a15.63,15.63,0,0,0-.65,8.94c-.7-.28-1.83-.76-3.12-1.32a17,17,0,0,1-1.54-.78c-4.8-2.77-5.9-7.17-2.18-10.54a30.35,30.35,0,0,0-6.22,6.73,6.51,6.51,0,0,1-.61-.33c-3.64-2.1-4.33-5.42-1.46-7.92.4-.35.81-.68,1.24-1a29.76,29.76,0,0,0-6.9,5.06c-3.59-2.11-3.58-5.55,0-7.64l5.77-3.36a32.15,32.15,0,0,0,14.44,3.89,40.3,40.3,0,0,0,6.87-.28,27,27,0,0,1,16.35,2.88c.16.09.32.18.47.28q2.13,1.32,4.33,2.59A187,187,0,0,0,404,135.68Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404,135.68c-3.53,2.1-9,2.47-13.23,1a105.7,105.7,0,0,1-16.95-7.76q-1.95-1.14-3.78-2.32a84.73,84.73,0,0,0,11.46,7.92,91.39,91.39,0,0,0,11.09,5.42c-7,1.49-14.65.52-19.79-2.45l-.62-.38a60.14,60.14,0,0,1-11.45-9.25,35.84,35.84,0,0,0,12.45,13l-.78-.08a36.25,36.25,0,0,1-13.57-4.24c-4.66-2.69-7.58-6.34-7.77-10.33v-.12a15.63,15.63,0,0,0-.65,8.94c-.7-.28-1.83-.76-3.12-1.32a17,17,0,0,1-1.54-.78c-4.8-2.77-5.9-7.17-2.18-10.54a30.35,30.35,0,0,0-6.22,6.73,6.51,6.51,0,0,1-.61-.33c-3.64-2.1-4.33-5.42-1.46-7.92.4-.35.81-.68,1.24-1a29.76,29.76,0,0,0-6.9,5.06c-3.59-2.11-3.58-5.55,0-7.64l5.77-3.36a32.15,32.15,0,0,0,14.44,3.89,40.3,40.3,0,0,0,6.87-.28,27,27,0,0,1,16.35,2.88c.16.09.32.18.47.28q2.13,1.32,4.33,2.59A187,187,0,0,0,404,135.68Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M302.23,132.47a1,1,0,0,1-.86-.49,1,1,0,0,1,.36-1.37l1.72-1a1,1,0,0,1,1,1.72l-1.72,1A.94.94,0,0,1,302.23,132.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.73,255.29h0a1,1,0,0,1-1-1c0-1.37.06-2.73.12-4.1a1,1,0,1,1,2,.08c-.06,1.35-.09,2.71-.12,4.06A1,1,0,0,1,226.73,255.29Zm.5-10.19h-.09a1,1,0,0,1-.9-1.09c.12-1.4.27-2.78.44-4.1a1,1,0,0,1,2,.26c-.17,1.29-.32,2.64-.44,4A1,1,0,0,1,227.23,245.1ZM228.7,235a.76.76,0,0,1-.21,0,1,1,0,0,1-.77-1.18c.3-1.37.63-2.72,1-4a1,1,0,1,1,1.92.55c-.35,1.26-.68,2.57-1,3.9A1,1,0,0,1,228.7,235Zm3-9.76a1,1,0,0,1-.38-.07,1,1,0,0,1-.55-1.3c.53-1.3,1.11-2.58,1.72-3.8a1,1,0,0,1,1.79.91c-.59,1.16-1.15,2.39-1.65,3.64A1,1,0,0,1,231.66,225.25Zm4.82-9a1,1,0,0,1-.57-.18,1,1,0,0,1-.25-1.39,38.77,38.77,0,0,1,2.58-3.3,1,1,0,0,1,1.51,1.32,36.39,36.39,0,0,0-2.45,3.13A1,1,0,0,1,236.48,216.28Zm6.89-7.49a1,1,0,0,1-.66-1.76c1-.89,2.09-1.76,3.15-2.63a1,1,0,1,1,1.27,1.54c-1,.86-2.09,1.72-3.11,2.6A1,1,0,0,1,243.37,208.79Zm7.79-6.59a1,1,0,0,1-.74-.33,1,1,0,0,1,.06-1.41,36.41,36.41,0,0,0,2.78-2.83,1,1,0,1,1,1.51,1.31,38.6,38.6,0,0,1-2.93,3A1,1,0,0,1,251.16,202.2Zm6.2-8a1,1,0,0,1-.41-.09,1,1,0,0,1-.5-1.33c.15-.32.28-.64.41-1a17.28,17.28,0,0,0,.77-2.69,1,1,0,1,1,2,.41,20.08,20.08,0,0,1-.86,3c-.14.37-.29.73-.46,1.09A1,1,0,0,1,257.36,194.19Zm1.9-10h0a1,1,0,0,1-1-1l.06-2c0-.71,0-1.42.07-2.12a1,1,0,0,1,2,.08c0,.7-.05,1.4-.07,2.1l-.06,2A1,1,0,0,1,259.26,184.23Zm.79-10.16-.19,0a1,1,0,0,1-.79-1.17,32.93,32.93,0,0,1,1.06-4.07,1,1,0,1,1,1.9.62,33.22,33.22,0,0,0-1,3.83A1,1,0,0,1,260.05,174.07Zm3.41-9.58a.92.92,0,0,1-.46-.11,1,1,0,0,1-.43-1.35c.63-1.21,1.35-2.42,2.12-3.6a1,1,0,0,1,1.38-.29,1,1,0,0,1,.29,1.38c-.74,1.13-1.41,2.28-2,3.44A1,1,0,0,1,263.46,164.49Zm5.74-8.41a1,1,0,0,1-.65-.24,1,1,0,0,1-.11-1.41c.88-1,1.83-2.05,2.81-3.06a1,1,0,0,1,1.43,1.41c-.95,1-1.87,2-2.72,2.95A1,1,0,0,1,269.2,156.08Zm7.27-7.16a1,1,0,0,1-.65-1.76c1-.87,2.12-1.74,3.23-2.58a1,1,0,0,1,1.21,1.59c-1.08.82-2.14,1.67-3.15,2.52A1,1,0,0,1,276.47,148.92Zm8.19-6.07a1,1,0,0,1-.54-1.84c1.13-.74,2.3-1.48,3.49-2.19a1,1,0,1,1,1,1.71c-1.16.7-2.32,1.42-3.43,2.15A1,1,0,0,1,284.66,142.85Zm8.75-5.25a1,1,0,0,1-.5-1.87l3.53-2a1,1,0,1,1,1,1.73l-3.54,2A.9.9,0,0,1,293.41,137.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.66,263.46h0a1,1,0,0,1-1-1v-2a1,1,0,0,1,2,0v2A1,1,0,0,1,226.66,263.46Z",
    style: {
      fill: "#e0e0e0"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesImage);
export default __webpack_public_path__ + "static/media/filesImage.2976a2f28dea253b4def5913eb14e8f5.svg";
export { ForwardRef as ReactComponent };